import store from '@/store'
import router from '@/router'
import axios from 'axios'
// import i18n from '@/i18n'

// const { t } = i18n.global

const ErrorHandler = class {
  handle(e) {
    const error = e?.response?.data || e?.response || e

    if (error.message == 'Network Error') {
      this.networkError()
    } else if (axios.isCancel(e)) {
      // Request canceled
    } else if (
      store.getters['auth/loggedIn'] &&
      e?.response?.status === 401 &&
      error.type === 'NotAuthorizedError'
    ) {
      this.unauthorizedError()
    } else if (store.getters['auth/loggedIn'] && e?.response?.status === 401) {
      this.notLoggedInError()
    } else if (error.full_messages || error.messages || error.message) {
      this.defaultError(error)
    } else {
      this.fallbackError(error)
    }

    return Promise.reject(error)
  }


  fallbackError(error) {
    store.dispatch('setAlert', {
      title: 'Unknown Error',
      messages: ['An unknown error occurred.', 'For the product team to figure out the problem, would you send this to the team?'],
      error: error
    })
  }

  defaultError(error) {
    store.dispatch('setAlert', {
      title: 'Something went wrong',
      messages: error.full_messages || error.messages || [error.message],
      buttonText: null,
    })
  }

  networkError() {
    store.dispatch('setAlert', {
      title: 'Seems like there are connection issues',
      messages: [
        'Check your internet connection.',
        'Make sure the API is available.',
      ],
      buttonText: 'Refresh',
    })
  }

  unauthorizedError() {
    store.dispatch('setAlert', {
      title: 'Unauthorized',
      messages: [
        'Sorry, you are not allowed to perform this action.',
        'If this is unexpected, please contact one of our staff!',
      ],
      buttonText: 'Back',
      buttonAction: () => router.go(-1),
    })
  }

  notLoggedInError() {
    router.replace({ name: 'Logout' })
    // store.dispatch('setAlert', {
    //   title: 'You need to be logged in',
    //   messages: [
    //     'Sorry, it seems that you have been logged out.',
    //     'Please log back in to access this page.',
    //   ],
    //   buttonText: 'Login',
    //   buttonAction: () => router.push({ name: 'Login' }),
    // })
  }
}

export default new ErrorHandler()
